import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";


const VisibilityButton: React.FC<{ showContent: boolean, changeVisibility: Function }> = ({ showContent, changeVisibility }) => {
    return <Button type="default" icon={showContent ? <EyeInvisibleOutlined /> : <EyeOutlined />} onClick={() => changeVisibility()}>{showContent ? "Hide" : "Show"}</Button>
}

export default VisibilityButton;